import { NotImplementedError } from "../../../../../errors";
import { normalizeUserEmail, OVERVIEW_VIEWER_EMAIL_FILTER, parseDateFilter } from "../../../../../models/looker/modules/overview";
import { PromiseHandler } from "../../../../../handlers";
import { FILTER_OPTIONS_MEDIA_TYPE_QUERY } from "../query";
export default class LookerOverviewMediaTypeFilter extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-overview-media-type-filter");
    }
    async findItems(filters) {
        // Required: without a range explore_overview falls back to the last 30
        // days, so products from an older selected range would be reported as
        // having no data.
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        const queryBody = {
            ...FILTER_OPTIONS_MEDIA_TYPE_QUERY,
            filters: {
                ...FILTER_OPTIONS_MEDIA_TYPE_QUERY.filters,
                "explore_overview.flt_date_range": parseDateFilter(dateFilter)
            }
        };
        // Fail closed: the media type (product group) list is partner-scoped
        // exclusively by the user email filter. Without a usable email the Looker
        // query would return every partner's media types (a cross-tenant leak), so
        // we refuse to run it.
        const userEmailFilter = filters.where?.find((filter) => filter.field === "userEmail");
        const userEmail = normalizeUserEmail(userEmailFilter?.value);
        if (!userEmail) {
            throw new Error("User email is required");
        }
        queryBody.filters[OVERVIEW_VIEWER_EMAIL_FILTER] = userEmail;
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch overview dashboard media type filter options");
        }));
    }
    formatResponse(data) {
        return data
            .filter((row) => row["explore_overview.product_group"])
            .map((row) => ({
            id: row["explore_overview.product_group"],
            name: row["explore_overview.product_group"]
        }));
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=MediaType.js.map